import {SelectField, SelectInput} from "react-admin";
import React from "react";

const types = [
    {id: 'BIKE', name: 'vehicleType.BIKE'},
    {id: 'BICYCLE', name: 'vehicleType.BICYCLE'},
    {id: 'CAR', name: 'vehicleType.CAR'},
]

export const EVehicleTypeField = (props) => (
    <SelectField source={props.source} choices={types} {...props} />
)

export const EVehicleTypeInput = (props) => (
    <SelectInput source={props.source} choices={types} {...props} />
)